module.exports = "/virtual-football-league/img/video/clubs/italy/inter.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/italy/inter.png
// module id = 348
// module chunks = 4